// extracted by mini-css-extract-plugin
export default {"category_div":"Home_category_div__M6DIm","main":"Home_main__x+OL6","carousel":"Home_carousel__7gHNO"};